<template>
	<section class="content-card auth-rules-card">
		<div class="section-heading">
			<div class="heading-icon"><i class="el-icon-document-checked"></i></div>
			<div>
				<h3>企业认证规则</h3>
				<p>企业账号与个人账号的认证、授权及权益规则说明</p>
			</div>
		</div>
		<div class="rules-table-wrap">
			<table class="rules-table">
				<thead>
					<tr>
						<th>项目</th>
						<th>企业用户</th>
						<th>个人用户</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in rules" :key="item.name">
						<td>{{ item.name }}</td>
						<td>{{ item.enterprise }}</td>
						<td>{{ item.personal }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</section>
</template>

<script>
	export default {
		name: 'CompanyAuthRules',
		data() {
			return {
				rules: [
					{ name: '登录方式', enterprise: '统一身份认证', personal: '手机号密码 / 统一身份认证' },
					{ name: '认证方式', enterprise: '登录即认证（默认）', personal: '由企业用户授权分配' },
					{ name: '能否自行认证', enterprise: '是（登录即认证）', personal: '否（需企业授权）' },
					{ name: '管理权限', enterprise: '可管理授权个人用户', personal: '仅管理自身' },
					{ name: '授权 / 解绑', enterprise: '可授权、解除绑定', personal: '解除绑定' },
					{ name: '领券 / 下单', enterprise: '支持', personal: '支持' },
					{
						name: '券与会员体系',
						enterprise: '与用户相关，与是否绑定企业无关，与企业权益无关',
						personal: '与用户相关，与是否绑定企业无关，与企业权益无关'
					},
					{ name: '授权用户数', enterprise: '最多可同时授权 5 个用户', personal: '/' },
					{
						name: '授权解绑规则',
						enterprise: '授权完成一周后才可解绑；用户解绑完成一周后才可再次被授权同一企业',
						personal: '授权完成一周后才可解绑；用户解绑完成一周后才可再次被授权同一企业'
					},
					{
						name: '授权时长',
						enterprise: '一次授权默认时长一年，一年后自动解除绑定',
						personal: '一次被授权默认时长一年，一年后自动解除绑定'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.content-card {
		margin-top: 20px;
		padding: 22px;
		border: 1px solid #e5eaf1;
		border-radius: 8px;
		background: #ffffff;
	}

	.section-heading {
		display: flex;
		align-items: center;
		margin-bottom: 20px;

		.heading-icon {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 42px;
			height: 42px;
			margin-right: 13px;
			border-radius: 10px;
			color: #2671cb;
			font-size: 22px;
			background: #edf5ff;
		}

		h3 {
			margin: 0 0 5px;
			font-size: 18px;
			color: #303846;
		}

		p {
			margin: 0;
			color: #9098a5;
			font-size: 13px;
		}
	}

	.rules-table-wrap {
		overflow-x: auto;
		border: 1px solid #e4eaf1;
		border-radius: 6px;
	}

	.rules-table {
		width: 100%;
		min-width: 760px;
		border-collapse: collapse;
		font-size: 14px;

		th,
		td {
			padding: 10px;
			border-right: 1px solid #e8edf3;
			border-bottom: 1px solid #e8edf3;
			text-align: left;
			line-height: 22px;
			vertical-align: top;
		}

		th {
			color: #354154;
			font-weight: 600;
			background: #f3f7fc;
		}

		td {
			color: #5f6978;

			&:first-child {
				width: 18%;
				color: #303846;
				font-weight: 500;
				background: #fafbfd;
			}
		}

		tr:last-child td {
			border-bottom: none;
		}

		th:last-child,
		td:last-child {
			border-right: none;
		}
	}
</style>
